<div class="export-progress" *ngIf="job" role="status" aria-live="polite">
  <div class="export-progress__card">
    <div class="export-progress__head">
      <span class="export-progress__spinner" *ngIf="job.percent === null"></span>
      <span class="export-progress__message">{{ message }}</span>
      <span class="export-progress__percent" *ngIf="job.percent !== null">{{ job.percent }}%</span>
    </div>

    <p class="export-progress__hint" *ngIf="hint">{{ hint }}</p>

    <div class="export-progress__track">
      <!-- Indeterminate whenever there is no honest percentage to show: while the server is
           still working, and while downloading a response that carried no Content-Length. -->
      <div class="export-progress__fill"
           [class.export-progress__fill--indeterminate]="job.percent === null"
           [style.width.%]="job.percent === null ? null : job.percent"></div>
    </div>

    <div class="export-progress__foot">
      <span class="export-progress__elapsed" [title]="'Time elapsed'">{{ elapsedLabel }}</span>
      <button type="button"
              class="export-progress__cancel"
              *ngIf="job.cancellable"
              (click)="cancel()"
              aria-label="Cancel export">Cancel</button>
    </div>
  </div>
</div>
